<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1"><span>Prologue</span></h1>
<p class="P_Body_Text"><span style=" font-weight: bold; font-size: 1.50em;">G</span>hosts come in all forms—memories that linger, déjà vu in a child’s smile, and occasionally, when the combination of death and pain is just right, they appear as human forms made of smoke and shadow that walk among the living.</p>
<p class="P_Body_Text">They wait and watch, looking for themselves in the living. Some mean harm, some want to help—to prevent others from making the mistake that condemned them to roam the earth. The lessons the dead have to teach are not always heard, but those who ignore the ghosts’ warnings do so at their own peril.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?c8d93bdc